export const DOT = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#E6007A" />
    <path
      d="M16 9.43569C18.2468 9.43569 20.0683 8.37586 20.0683 7.06849C20.0683 5.76113 18.2468 4.70129 16 4.70129C13.7531 4.70129 11.9316 5.76113 11.9316 7.06849C11.9316 8.37586 13.7531 9.43569 16 9.43569Z"
      fill="white"
    />
    <path
      d="M16 27.2657C18.2468 27.2657 20.0683 26.2058 20.0683 24.8985C20.0683 23.5911 18.2468 22.5312 16 22.5312C13.7531 22.5312 11.9316 23.5911 11.9316 24.8985C11.9316 26.2058 13.7531 27.2657 16 27.2657Z"
      fill="white"
    />
    <path
      d="M10.3296 12.7097C11.453 10.7638 11.4459 8.65647 10.3137 8.00279C9.18147 7.3491 7.35291 8.39661 6.22947 10.3425C5.10604 12.2883 5.11315 14.3956 6.24537 15.0493C7.37758 15.703 9.20615 14.6555 10.3296 12.7097Z"
      fill="white"
    />
    <path
      d="M25.7705 21.6246C26.8939 19.6787 26.8868 17.5714 25.7546 16.9177C24.6224 16.264 22.7938 17.3115 21.6704 19.2574C20.547 21.2032 20.5541 23.3106 21.6863 23.9642C22.8185 24.6179 24.6471 23.5704 25.7705 21.6246Z"
      fill="white"
    />
    <path
      d="M10.3137 23.9641C11.4459 23.3104 11.453 21.2031 10.3296 19.2573C9.20615 17.3114 7.37758 16.2639 6.24537 16.9176C5.11315 17.5713 5.10604 19.6786 6.22947 21.6245C7.35291 23.5703 9.18147 24.6178 10.3137 23.9641Z"
      fill="white"
    />
    <path
      d="M25.7546 15.0493C26.8868 14.3957 26.8939 12.2883 25.7705 10.3425C24.6471 8.39662 22.8185 7.34912 21.6863 8.0028C20.5541 8.65649 20.547 10.7638 21.6704 12.7097C22.7938 14.6555 24.6224 15.703 25.7546 15.0493Z"
      fill="white"
    />
  </svg>
);
